/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Frontend SPA Contract API
 * Canonical API contract entrypoint.
 *
 * Source architecture:
 * - split by module / bounded context
 * - one file per aggregate root
 * - child entities remain owned by aggregate root
 * - cross-cutting technical concerns live under `openapi/common`
 *
 * OpenAPI spec version: 1.0.0
 */
import * as zod from "zod";

import {
  CheckLeadSimilarityRequest,
  CheckLeadSimilarityResult,
  ConvertLeadToClientRequest,
  CountryCode,
  CreateLeadRequest,
  HeliportEnvironment,
  LeadDto,
  PaginatedLeadDto,
  UpdateLeadRequest,
} from "../__ignore/schemas";

/**
 * Computes advisory same-country similarity against active and deleted Leads and Clients without creating or changing a resource.
 * @summary Check lead similarity
 */
export const CheckLeadSimilarityBody = CheckLeadSimilarityRequest;

export const CheckLeadSimilarityResponse = CheckLeadSimilarityResult;

/**
 * @summary Get lead
 */
export const getLeadQueryIncludeDeletedDefault = false;

export const GetLeadQueryParams = zod.object({
  includeDeleted: zod.coerce.boolean().default(getLeadQueryIncludeDeletedDefault),
});

export const GetLeadResponse = LeadDto;

/**
 * @summary Update lead
 */
export const UpdateLeadBody = UpdateLeadRequest;

export const UpdateLeadResponse = zod.void();

/**
 * @summary Delete lead
 */
export const DeleteLeadResponse = zod.void();

/**
 * @summary Convert lead to client
 */
export const ConvertLeadToClientBody = ConvertLeadToClientRequest;

export const ConvertLeadToClientResponse = zod.uuid();

/**
 * @summary List leads
 */

export const listLeadsQueryPerPageMax = 100;

export const listLeadsQuerySortKeyDefault = `leadId`;
export const listLeadsQueryStateDefault = `ACTIVE`;

export const ListLeadsQueryParams = zod.object({
  page: zod.coerce.number().int().min(1).describe("Page number (1-indexed)"),
  perPage: zod.coerce
    .number()
    .int()
    .min(1)
    .max(listLeadsQueryPerPageMax)
    .describe("Number of items per page"),
  q: zod.coerce.string().optional().describe("Free-text search query"),
  sortKey: zod
    .enum(["leadId", "companyName"])
    .default(listLeadsQuerySortKeyDefault)
    .describe("Lead sort key"),
  sortDir: zod.enum(["asc", "desc"]).optional().describe("Sort direction"),
  state: zod
    .enum(["ACTIVE", "DELETED", "ALL"])
    .default(listLeadsQueryStateDefault)
    .describe("Lead state filter"),
  countryCodes: zod.array(CountryCode).optional().describe("Lead country filter"),
  environments: zod.array(HeliportEnvironment).optional().describe("Lead environment filter"),
  createdFrom: zod.iso.datetime({offset: true}).optional().describe("Inclusive creation timestamp"),
  createdBefore: zod.iso
    .datetime({offset: true})
    .optional()
    .describe("Exclusive creation timestamp"),
});

export const ListLeadsResponse = PaginatedLeadDto;

/**
 * @summary Create lead
 */
export const CreateLeadBody = CreateLeadRequest;

export const CreateLeadResponse = zod.uuid();

/**
 * @summary Restore lead
 */
export const RestoreLeadResponse = zod.void();
